import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ChartFilterControlsInterface, ReportInputTypes } from 'src/app/shared/models/common';

@Component({
  selector: 'app-user-activity-running-loans',
  templateUrl: './user-activity-running-loans.component.html',
  styleUrls: ['./user-activity-running-loans.component.css']
})
export class UserActivityRunningLoansComponent implements OnInit {

  public hideFilters: boolean = false

  public runningLoansForm: FormGroup
  public runningLoansFormControls: ChartFilterControlsInterface[] = [
    { name: ReportInputTypes.LOAN_PRODUCT, type: 'LOAN_PRODUCT', position: 'right' },
  ]
  
  constructor() { }

  ngOnInit(): void {
  }

  filterRunningLoans(ev: any) {
  }

}
